import { createQueryKeys } from "@lukemorales/query-key-factory";

import { listOrganizationNotifyList } from "../api/providers";

export const organizationNotifyListQueryOptionsFactory = createQueryKeys(
  "organization-notify-list",
  {
    list: (organizationId: string) => ({
      queryKey: [organizationId],
      queryFn: () => listOrganizationNotifyList(organizationId),
    }),
  },
);
